document.addEventListener("DOMContentLoaded", function() {
  
  var targetDiv = document.querySelector(".regal-collection-link");
  if (targetDiv) {
    targetDiv.style.cursor = "pointer"; // make it look clickable
    targetDiv.addEventListener("click", function() {
      window.location.href = "/collections/the-regal-silhouette";
    });
  }

  var targetDiv = document.querySelector(".wedding-edit-link");
  if (targetDiv) {
    targetDiv.style.cursor = "pointer"; // make it look clickable
    targetDiv.addEventListener("click", function() {
      window.location.href = "/collections/the-wedding-edit";
    });
  }
  

  
  var targetDiv = document.querySelector(".show-stopper");
  if (targetDiv) {
    targetDiv.style.cursor = "pointer"; // make it look clickable
    targetDiv.addEventListener("click", function() {
      window.location.href = "/collections/show-stopper";
    });
  }


  var targetDiv = document.querySelector(".prasang");
  if (targetDiv) {
    targetDiv.style.cursor = "pointer"; // make it look clickable
    targetDiv.addEventListener("click", function() {
      window.location.href = "/collections/prasang";
    });
  }

  var targetDiv = document.querySelector(".sehra");
  if (targetDiv) {
    targetDiv.style.cursor = "pointer"; // make it look clickable
    targetDiv.addEventListener("click", function() {
      window.location.href = "/collections/sehra";
    });
  }

var targetDiv = document.querySelector(".tyohar");
  if (targetDiv) {
    targetDiv.style.cursor = "pointer"; // make it look clickable
    targetDiv.addEventListener("click", function() {
      window.location.href = "/collections/ethnic-tyohar";
    });
  }


});

// Accordion functionality
document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
        const item = header.parentElement;
        item.classList.toggle('active');
    });
});


